import React from 'react';
import useRequestConfigs from '../../../hooks/useRequestConfigs';
/**
 * Renders the 'no results' component if search results returns no items.
 *
 * @component
 * @returns {JSX.Element} The 'no results' component
 */
export default function ZeroResults() {
    const { getRequestConfigs } = useRequestConfigs();
    const { query } = getRequestConfigs();
    if (query) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'cio-zero-results-header' },
                "Sorry, we didn\u2019t find: \u201C",
                query,
                "\u201D"),
            React.createElement("ul", { className: 'cio-zero-results-option-list' },
                React.createElement("li", null, "Check for typos"),
                React.createElement("li", null, "Use fewer keywords"),
                React.createElement("li", null, "Broaden your search terms"))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'cio-zero-results-header' }, "Sorry, we were unable to find what you were looking for."),
        React.createElement("ul", { className: 'cio-zero-results-option-list' },
            React.createElement("li", null, "Check for typos"),
            React.createElement("li", null, "Use fewer keywords"),
            React.createElement("li", null, "Broaden your search terms"))));
}
